export default "__VITE_ASSET__DCtth$TT__"